// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.About_About__aNTOI .About_content__clLqi {
  padding: 2.5rem;
}
.About_About__aNTOI .About_content__clLqi .About_aboutMe__NF8Ey {
  border-radius: 50vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.About_About__aNTOI .About_content__clLqi .About_contactContainer__vx8SB {
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.About_About__aNTOI .About_content__clLqi .About_contactContainer__vx8SB .About_contactHeader__6fX8L {
  font-size: 1.2rem;
}
.About_About__aNTOI .About_content__clLqi .About_contactContainer__vx8SB .About_contactLinksRow__7eKNR {
  display: inherit;
  flex-direction: row;
  margin: 2vh;
}
.About_About__aNTOI .About_content__clLqi .About_contactContainer__vx8SB .About_contactLinks__-Jtbz {
  border-radius: 1rem;
  display: flex;
}
.About_About__aNTOI .About_content__clLqi .About_darkTheme__z2J7O {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
}
.About_About__aNTOI .About_content__clLqi .About_lightTheme__WHR3J {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
}
.About_About__aNTOI .About_content__clLqi .About_colorfulTheme__gOOrg {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/views/About/About.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAIE;EACE,eCDgC;ADFpC;AAKI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHN;AAOI;EACE,kBCZ8B;EDa9B,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AALN;AAOM;EACE,iBAAA;AALR;AAQM;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AANR;AASM;EACE,mBC9Ba;ED+Bb,aAAA;AAPR;AAmBI;ECWF,gBAAA;EACA,sBAAA;EACA,2CAnD4B;ED+BxB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBCxCe;ADkCrB;AAcI;ECYF,gBAAA;EACA,sBAAA;EACA,0CAxD6B;ED8BzB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBCxCe;AD4CrB;AASI;ECaF,gBAAA;EACA,sBAAA;EACA,0CA9D6B;ED8BzB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBCxCe;ADsDrB","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.About {\n\n  .content {\n    padding: $globalHomeContentContainerPadding;\n\n    .aboutMe {\n      border-radius: 50vw;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n\n    .contactContainer {\n      margin-top: $globalHomeContentContainerPadding;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n\n      .contactHeader {\n        font-size: calc($globalFontSize);\n      }\n\n      .contactLinksRow {\n        display: inherit;\n        flex-direction: row;\n        margin: 2vh;\n      }\n\n      .contactLinks {\n        border-radius: $globalBorderRadius;\n        display: flex;\n      }\n    }\n\n    @mixin contentStyling {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      border-radius: $globalBorderRadius;\n    }\n\n    .darkTheme {\n      @include darkThemeContent;\n      @include contentStyling;\n    }\n\n    .lightTheme {\n      @include lightThemeContent;\n      @include contentStyling;\n    }\n\n    .colorfulTheme {\n      @include colorfulThemeContent;\n      @include contentStyling;\n    }\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"About": `About_About__aNTOI`,
	"content": `About_content__clLqi`,
	"aboutMe": `About_aboutMe__NF8Ey`,
	"contactContainer": `About_contactContainer__vx8SB`,
	"contactHeader": `About_contactHeader__6fX8L`,
	"contactLinksRow": `About_contactLinksRow__7eKNR`,
	"contactLinks": `About_contactLinks__-Jtbz`,
	"darkTheme": `About_darkTheme__z2J7O`,
	"lightTheme": `About_lightTheme__WHR3J`,
	"colorfulTheme": `About_colorfulTheme__gOOrg`
};
export default ___CSS_LOADER_EXPORT___;
